






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface Budget {
    validationDeadline: string;
}

@Component({ components: { } })
export default class ValidationDeadline extends Vue {
    @Prop() public budget!: Budget;

    public static getNeededFields(): string[] {
        return [
            "budget.validationDeadline",
        ];
    }
}
